export default "__VITE_ASSET__MBPj$day__"